const ViewTypes = {
  FullCardView: "FullCardView",
  ListView: "ListView",
  MultipleCardView: "MultipleCardView",
};

export default ViewTypes;
